import { Injectable } from "@angular/core";
import { map, Observable, shareReplay, switchMap } from "rxjs";
import { Vehicle } from "../models/vehicle";
import { ApolloClientService } from "./apollo-client.service";
import { GraphqlVehicleOutput } from "../graphql/models/output/vehicle-output.model";
import { VehiclesQueries } from "../graphql/queries/vehicles.queries";
import { convertGraphqlVehicleOutputToVehicle } from "../graphql/mappers/vehicle.mappers";

/**
 * Service handling delivery data.
 */
@Injectable({
  providedIn: 'root' 
})
export class VehiclesService {

    private allVehicles$: Observable<Vehicle[]> | null = null;

    constructor(private apolloClientService: ApolloClientService) {}


    public getAllVehicles$(): Observable<Vehicle[]> {
		if (!this.allVehicles$) {
			this.allVehicles$ = this.apolloClientService.abstractionLayerClient$.pipe(
				switchMap(client =>
					client.query<{ bookingGetVehicleDetailsFromTestIt: GraphqlVehicleOutput[] }>({
						query: VehiclesQueries.getAllVehicles,
						variables: { },
						fetchPolicy: 'no-cache',
					}),
				),
				map(result => {
					return result.data.bookingGetVehicleDetailsFromTestIt.map((vehicle) => convertGraphqlVehicleOutputToVehicle(vehicle))}
				),
				map(reslut => reslut ? reslut : []),
				shareReplay(1),
			);
		}
		return this.allVehicles$;
	}
}